import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const ProductBanner = (props) => {
  const { className, children } = props;
  return (
    <div className={cn('c-product-banner', className)}>
      <div className="u-clearfix">{children}</div>
    </div>
  );
};

export default ProductBanner;

ProductBanner.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
};

ProductBanner.defaultProps = {
  className: '',
};
